module.exports = __webpack_public_path__ + "img/09_Heizungsinstallateur_Foto_2022.5763cdf0.jpg";